/* global axios */
import ApiClient from './ApiClient';

class FunnelsAPI extends ApiClient {
  constructor() {
    super('analytics/funnels', { accountScoped: true });
  }

  query(payload) {
    return axios.post(`${this.url}/query`, { funnel: payload });
  }
}

export default new FunnelsAPI();
